import { lazy, Suspense } from 'react';

import { useUIPreference } from '@shared-legacy/contexts/UIPreferenceContext';
import { Loader, loaderStylesSpinnerXLarge } from '@shared-legacy/ui-kit';

const LegacyApp = lazy(() => import('@app-legacy/App'));
const ModernApp = lazy(() => import('@app/App'));

const AppFallback = () => <Loader styles={loaderStylesSpinnerXLarge} label="Loading..." />;

export const AppSwitch = () => {
  const { uiMode } = useUIPreference();

  return (
    <Suspense fallback={<AppFallback />}>
      {uiMode === 'modern' ? (
        <div className="ui-v2">
          <ModernApp />
        </div>
      ) : (
        <LegacyApp />
      )}
    </Suspense>
  );
};
